import Vue from 'vue';
import JmmToast from './toast.vue'

const ToastConstructor = Vue.extend(JmmToast);
let toastPool = [];

let getAnInstance = () => {
  
  if (toastPool.length > 0) {
    let instance = toastPool[0];
    toastPool.splice(0, 1);
    
    return instance;
  }
  return new ToastConstructor({
    el: document.createElement('div')
  });
};

let returnAnInstance = instance => {
  if (instance) {
    toastPool.push(instance);
  }
};



ToastConstructor.prototype.close = function() {
  this.isShow = false;
  this.$el.remove();
  this.closed = true;
  returnAnInstance(this);
};

let Toast =(options = {}) =>{
  
  let duration = options.duration || 5000;

  let instance =getAnInstance()

  instance.closed = false;
  
  clearTimeout(instance.timer);

  instance.message = typeof options === 'string' ? options : options.message;
  instance.round = options.round === undefined ? true : options.round;
  instance.type = options.type || 'normal',
  instance.status = options.status || 'success',
  instance.position = options.position || '',
  instance.callback = options.callback || null,
 
  document.body.appendChild(instance.$el);
  Vue.nextTick(function() {
    instance.isShow = true;

    instance.timer = setTimeout(function() {
      if (instance.closed)  return;

      instance.close();

      if(instance.callback){
        instance.callback();
      }
     
    }, duration);

  });
  return instance;



}

export default Toast;






// WEBPACK FOOTER //
// ./src/components/JmmToast/index.js